import axios from "axios";
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { endpoint: String, pkey: String, callbackUrl: String}

  connect() {
    initEzidebitInputs()
    this.initPayNow()
  }

  initPayNow() {
    const pkey = this.pkeyValue
    const endpoint = this.endpointValue

    eziDebit.init(pkey, {
      submitAction: "ChargeCard",
      submitButton: "payNowButton",
      submitCallback: (data) => this.submitSuccessCallback(data),
      submitError: (data) => this.displaySubmitError(data),
      nameOnCard: "nameOnCard",
      cardNumber: "cardNumber",
      cardExpiryMonth: "expiryMonth",
      cardExpiryYear: "expiryYear",
      cardCCV: "ccv",
      paymentAmount: "amount",
      paymentReference: "paymentReference"
    }, endpoint);
  }

  submitSuccessCallback(data) {
    if (data["ErrorMessage"] != null) {
      this.displaySubmitError(data["ErrorMessage"])
    } else {
      let paymentData = data

      Object.assign(paymentData, {
        amount: $("#amount").val(),
        payment_reference: $("#paymentReference").val(),
        masked_card_number: maskString($("#cardNumber").val())
      });
      this.createPayment(paymentData)
    }
  }

  displaySubmitError(data) {
    bootbox.alert({
      title: formatBootboxTitle(false, "Failed"),
      className: "failure-modal",
      message: data,
      callback: function() {
        enableSubmitButton("#payNowButton", "Pay Now")
      }
    })
  }

  createPayment(paymentData) {
    const url = this.callbackUrlValue
    const authenticityToken = $('input[name="authenticity_token"]').val();
    axios.post(url,
      { authenticity_token: authenticityToken, transaction: paymentData },
      { headers: { 'Accept': 'text/vnd.turbo-stream.html' } }
    )
    .then(response => {
      Turbo.renderStreamMessage(response.data);
    })
    .catch(error => {
      showErrorMessage(error);
    });
  }
}